import AppHeader from './AppHeader.vue';

export default AppHeader;
